import { useState, useEffect } from 'react';
import '../Styles/Menu.css'
import hamburger from '../HamburgerIcon.png'
import closed from '../Close.png'
import '../Styles/Hamburger.css'
import logo from '../Logo.png'
import { GiHamburgerMenu } from "react-icons/gi";
import { VscChromeClose } from "react-icons/vsc";
import PhoneNumber from './PhoneNumber';

function Menu(params) {
    const [clicked, setClicked] = useState(true)
    const [scrollPosition, setScrollPosition] = useState(0);
    const [screenWidth, setScreenWidth] = useState(0)
    useEffect(() => {
        if (typeof window !== "undefined") {

            const handleScroll = () => {
                const position = window.scrollY;

                setScrollPosition(position);

            }
            const handleScreenChange = () => {
                const width = window.innerWidth;
                console.log(width)
                setScreenWidth(width)
            }

            window.addEventListener("scroll", handleScroll);
            window.addEventListener("resize", handleScreenChange);

            return () => {
                window.removeEventListener("scroll", handleScroll);
                window.removeEventListener("resize", handleScreenChange);
            }
        }
    }, [])

    if (scrollPosition < 50) {
        return (

            <div className="Menu">
                <a href='/'>
                    <img src={logo} alt="Anderson Taxes Logo" />
                </a>
                <div className='Centered'>
                    <h1>Anderson's Taxes</h1>
                    <h3>Preparing under XIT Financial Services LLC</h3>
                </div>
                {clicked &&
                    <div className="Hamburger"><GiHamburgerMenu onClick={() => setClicked(!clicked)} /></div>
                }
                {!clicked && <div className='Hamburger'><VscChromeClose onClick={() => setClicked(!clicked)} /></div>}
                <div className={"MenuPages"}>

                    {/* <div className="MenuPageLink"><a href="/aboutUs">About Us</a></div>
                <div className="MenuPageLink"><a href="/Services">Services</a></div>
            <div className="MenuPageLink"><a href="/UploadDocuments">Documents</a></div>
            <div className="MenuPageLink"><a href="/ContactUs">Contact</a></div> */}
                    <div className="MenuPageLink"><a onClick={() => params.setPath("AboutUs")}>About Us</a></div>
                    <div className="MenuPageLink"><a onClick={() => params.setPath("Services")}>Services</a></div>
                    <div className="MenuPageLink"><a onClick={() => params.setPath("ContactUs")}>Contact</a></div>
                    <div className="MenuPageLink"><a onClick={() => params.setPath("Documents")}>Documents</a></div>
                </div>
                {!clicked &&
                    <div className={"MenuPagesMobile"}>
                        {/* <div className="MenuPageLinkMobile"><a href="/aboutUs">About Us</a></div>
                    <div className="MenuPageLinkMobile"><a href="/Services">Services</a></div>
                    <div className="MenuPageLinkMobile"><a href="/UploadDocuments">Documents</a></div>
                    <div className="MenuPageLinkMobile"><a href="/ContactUs">Contact</a></div> */}
                        <div className="MenuPageLinkMobile"><a onClick={() => params.setPath("AboutUs")}>About Us</a></div>
                        <div className="MenuPageLinkMobile"><a onClick={() => params.setPath("Services")}>Services</a></div>
                        <div className="MenuPageLinkMobile"><a onClick={() => params.setPath("Documents")}>Documents</a></div>
                        <div className="MenuPageLinkMobile"><a onClick={() => params.setPath("ContactUs")}>Contact</a></div>
                    </div>
                }

            </div>

        )
    }
    else if (screenWidth > 768) {
        return (

            <div className="Menu">
                <a href='/'>
                    <img src={logo} alt="Anderson Taxes Logo" />
                </a>
                <div className='Centered'>
                    <h1>Anderson's Taxes</h1>
                    <h3>Preparing under XIT Financial Services LLC</h3>
                </div>
                {clicked &&
                    <div className="Hamburger"><GiHamburgerMenu onClick={() => setClicked(!clicked)} /></div>
                }
                {!clicked && <div className='Hamburger'><VscChromeClose onClick={() => setClicked(!clicked)} /></div>}
                <div className={"MenuPages"}>

                    {/* <div className="MenuPageLink"><a href="/aboutUs">About Us</a></div>
                <div className="MenuPageLink"><a href="/Services">Services</a></div>
            <div className="MenuPageLink"><a href="/UploadDocuments">Documents</a></div>
            <div className="MenuPageLink"><a href="/ContactUs">Contact</a></div> */}
                    <div className="MenuPageLink"><a onClick={() => params.setPath("AboutUs")}>About Us</a></div>
                    <div className="MenuPageLink"><a onClick={() => params.setPath("Services")}>Services</a></div>
                    <div className="MenuPageLink"><a onClick={() => params.setPath("ContactUs")}>Contact</a></div>
                    <div className="MenuPageLink"><a onClick={() => params.setPath("Documents")}>Documents</a></div>
                </div>
                {!clicked &&
                    <div className={"MenuPagesMobile"}>
                        {/* <div className="MenuPageLinkMobile"><a href="/aboutUs">About Us</a></div>
                    <div className="MenuPageLinkMobile"><a href="/Services">Services</a></div>
                    <div className="MenuPageLinkMobile"><a href="/UploadDocuments">Documents</a></div>
                    <div className="MenuPageLinkMobile"><a href="/ContactUs">Contact</a></div> */}
                        <div className="MenuPageLinkMobile"><a onClick={() => params.setPath("AboutUs")}>About Us</a></div>
                        <div className="MenuPageLinkMobile"><a onClick={() => params.setPath("Services")}>Services</a></div>
                        <div className="MenuPageLinkMobile"><a onClick={() => params.setPath("Documents")}>Documents</a></div>
                        <div className="MenuPageLinkMobile"><a onClick={() => params.setPath("ContactUs")}>Contact</a></div>
                    </div>
                }

            </div>

        )
    }
    else {
        return (

            <div className="Menu ">
                <a href='/' className='ShortMenu Centered'>
                    <img src={logo} alt="Anderson Taxes Logo" />

                    <a href="callto:8013729613">(435) 314-8330</a>

                </a>
            </div>

        )
    }


}

export default Menu;